import { graphql } from '../../../gql';

// TRIL-305: codegen graphql() op (not Apollo's untyped `gql`) — the other writer
// of userStore.user besides getUser. Typing `data.loginUser` means a dropped
// auth-critical selection fails `tsc` at the consumer. Selection set unchanged.
export const LOGIN_MUTATION = graphql(`
    mutation loginUser($input: LoginInput!) {
        loginUser(input: $input) {
            id
            interests
            newUser
            username
            firstName
            lastName
            email
            country
            zipPostalCode
            role
            active
            avatar
            bio
            accessToken
            refreshToken
            sessionId
            lastActive
            createdAt
            authorReputation {
                sentiment
                volatilityIndex
                metrics {
                    posts
                    following
                    followers
                }
            }
            userProfile {
                isPublicPerson
                displayName
                professionalContext {
                    expertiseAreas
                    educationLevel
                    currentProgram
                    fieldOfStudy
                    institution
                    jobTitle
                    yearsExperience
                    credentials {
                        id
                        title
                        issuer
                        year
                        expiryYear
                        link
                    }
                    updatedAt
                }
            }
            userPreferences {
                theme
                landingPage
                avatarUrl
                planCNudgeDismissedAt
                planCNudgeDismissCount
                planCPromptDismissCount
                planCOptedOut
                navCollapsed
            }
            upVotedPosts
            downVotedPosts
        }
    }
`);
